<!-- <div class="pos-rel"> -->
<div class="bg-lightt pos-rel">
  <!-- sticky butttons -->
  <!-- <div class="sticky-1-v4">
    <img
      class="sticky-1-v4-icone"
      src="../../../../assets/v-4-icone/Vector.svg"
      alt="loading"
    />
  </div>
  <div class="sticky-2-v4">
    <img
      class="sticky-2-v4-icone"
      src="../../../../assets/v-4-icone/Vector(2).svg"
      alt="loading"
    />
  </div> -->
  <!-- sticky butttons -->

  <div class="container max-width">
    <div class="d-flex justify-content-center py-1"></div>
    <app-skelitions [hidden]="!skelition" [value]="6" class="mb-2"></app-skelitions>
    <span [hidden]="skelition">
      <p-dataView #dv [value]="filteredData" layout="grid" filterBy="type.name,name" [rows]="48" [paginator]="false"
        [sortField]="sortField" [sortOrder]="sortOrder" gridStyleClass=" column-gap-1" class="flex-v4">
        <ng-template pTemplate="header">
          <div class="row py-3 justify-content-between">
            <!-- <div class="col-md-4 col-12">
              <span class="p-float-label">
                <p-dropdown
                  appendTo="body"
                  styleClass="sstarabic"
                  [options]="sortOptions"
                  [(ngModel)]="sortKey"
                  placeholder="{{ 'sort by' | translator }}"
                  (onChange)="onSortChange($event)"
                  styleClass="md:mb-0"
                >
                  <ng-template let-item pTemplate="item">
                    <i [ngClass]="item.icon"></i>
                    {{ item.label }}
                  </ng-template>
                </p-dropdown>
                <label> {{ "sort by" | translator }} </label>
              </span>
            </div> -->

            <div class="col-md-4 col-12">
              <span class="p-float-label mobile-margin">
                <input class="mob-width w-100" id="mob-label" type="text" pInputText size="50" placeholder="{{
                    'Name of the entity or ministry' | translator
                  }}" (keyup)="applyFilterGlobal($event)" style="width: auto" />
                <label for="mob-label">
                  {{ "Search for entities and ministries" | translator }}</label>
              </span>
            </div>

            <div class="col-md-4 col-12 d-flex flex-wrap gap-2 justify-content-center align-items-center">
              <ng-container *ngFor="let type of uniqueTypeNames">
                <div class="d-flex">
                  <p-radioButton (onClick)="applyTypeFilter($event.value)" name="type" [value]="type"
                    [(ngModel)]="entitytype" inputId="i1"></p-radioButton>
                  <label for="i1" class="mx-2"> {{ type }} </label>
                </div>
              </ng-container>
              <div class="d-flex">
                <p-radioButton (onClick)="applyTypeFilter($event.value)" name="type" value="all"
                  [(ngModel)]="entitytype" inputId="i3"></p-radioButton>
                <label for="i1" class="mx-2">
                  {{ "All entities and ministries" | translator }}
                </label>
              </div>
            </div>
          </div>
        </ng-template>

        <ng-template let-entity pTemplate="gridItem">
          <div class="pos-rel">
            <div style="
                height: 130px;
                width: 130px;
                background-color: white;
                border-radius: 17px;
              " class="zoomIn mx-2 my-2 {{
                entity._id == current?._id ? 'bg-primary' : ''
              }}" (mouseenter)="onMouseEnter(entity)" (mouseleave)="onMouseLeave($event, entity)"
              (click)="handleClick(false, entity)">
              <div class="main-card">
                <div class="card-content product-grid-item {{
                    entity._id == current?._id ? 'bg-primary' : ''
                  }}">
                  <i *ngIf="
                      entity &&
                      entity.children &&
                      getWithService(entity.children ?? []).length > 0
                    " class="haschildren pi pi-star-fill text-3xl"
                    [pTooltip]="'this entity has sub divisions' | translator" tooltipPosition="top"></i>

                  <div class="card-image">
                    <img src="{{ staticURL + entity.image_sq }}" *ngIf="checkisImg(entity?.image_sq); else elseBlock"
                      class="img-fluid minis-img" alt="loading..." />
                    <div class="product-name px-2 mob-block-web-none">
                      {{ entity.name }}
                    </div>
                    <ng-template #elseBlock>
                      <i class="pi pi-{{ entity?.image_sq }}" style="font-size: 2.5rem"></i>
                    </ng-template>
                  </div>

                  <!--  -->
                  <div class="card-text">
                    <div class="product-name px-2">{{ entity.name }}</div>

                    <div class="product-tags">
                      <p-tag class="m-y-x-2" *ngFor="
                          let counter of dataSorter(
                            entity?.data_counter,
                            entity?._id
                          );
                          let i = index
                        " [rounded]="false" icon="{{ counter.icon }} pi-fw" styleClass="bg-color-{{ i }}"
                        [pTooltip]="entity &&
                        entity.children &&
                        getWithService(entity.children ?? []).length > 0
                          ? null
                          : counter._id" tooltipPosition="top"
                        >
                        {{ counter?.count }}
                      </p-tag>
                    </div>
                  </div>
                  <!--  -->
                </div>
              </div>
            </div>

            <div class="custom-card-hover w-100 pos-abs card-max-width" [hidden]="!entityHover[entity.id] || true"
              (mouseenter)="entityHover[entity.id] = true" (mouseleave)="entityHover[entity.id] = false">
              <div class="d-flex flex-row gap-2 flex-wrap justify-content-center">
                <p-button *ngFor="
                    let counter of dataSorter(
                      entity?.data_counter,
                      entity?._id
                    );
                    let i = index
                  " class="full-width-button" (onClick)="OpenServicesPage(entity.id, counter._id)"
                  [icon]="counter.icon" styleClass="bg-color-{{ i }} counterbuttons" [label]="counter._id" size="small"
                  [badge]="counter.count.toString()"></p-button>
              </div>
            </div>

            <div *ngIf="
                current &&
                entity._id == current?._id &&
                showChildren &&
                currentChildren
              " class="w-100 d-flex justify-content-center">
              <i class="fa fa-angle-down left-arrow-ui"></i>
            </div>
          </div>

          <div class="d-flex flex-row flex-wrap p-1 card mx-1 my-1 bg-primary w-100 justify-content-center" *ngIf="
              showChildren &&
              current &&
              entity._id == current._id &&
              currentChildren
            ">
            <div class="pos-rel" *ngFor="let child of currentChildren">
              <div style="
                  height: 130px;
                  background-color: white;
                  border-radius: 6px;
                  width: 130px;
                " class="mx-2 my-2" (mouseenter)="entityHover[child.id] = true"
                (mouseleave)="entityHover[child.id] = false" (click)="handleClick(true, child)">
                <div class="main-card product-grid-item">
                  <div class="card-image">
                    <img src="{{ staticURL + child.image_sq }}" *ngIf="checkisImg(child?.image_sq); else elseBlock"
                      class="img-fluid minis-img" alt="loading..." />
                    <ng-template #elseBlock>
                      <i class="pi pi-{{ child?.image_sq }}" style="font-size: 2.5rem"></i>
                    </ng-template>
                  </div>
                  <div class="card-text">
                    <div class="product-name px-2">{{ child.name }}</div>
                    <div class="product-tags">
                      <p-tag class="m-y-x-2" *ngFor="
                          let counter of dataSorter(
                            child?.data_counter,
                            child?._id
                          );
                          let i = index
                        " [rounded]="false" icon="{{ counter.icon }} pi-fw" styleClass="bg-color-{{ i }}"
                        [pTooltip]="counter._id" tooltipPosition="top">
                        {{ counter?.count }}
                      </p-tag>
                    </div>
                  </div>
                </div>
              </div>

              <div class="custom-card-hover w-100 pos-abs card-max-width" [hidden]="!entityHover[child.id!] || true"
                (mouseenter)="entityHover[child.id] = true" (mouseleave)="entityHover[child.id] = false">
                <div class="spacer"></div>
                <div class="d-flex flex-row gap-2 flex-wrap justify-content-center">
                  <p-button *ngFor="
                      let counter of dataSorter(child?.data_counter, child._id);
                      let i = index
                    " class="full-width-button" (onClick)="OpenServicesPage(child.id, counter._id)"
                    [icon]="counter.icon" styleClass="bg-color-{{ i }} counterbuttons" [label]="counter._id"
                    size="small" [badge]="counter.count.toString()"></p-button>
                </div>
              </div>
            </div>
          </div>
        </ng-template>

        <ng-template let-item pTemplate="paginatordropdownitem">
          {{ item.value }} - per page
        </ng-template>
      </p-dataView>
    </span>
  </div>
</div>
<!-- </div> -->